/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const UPLOAD = "UPLOAD";
export const GET_UGC_SWATCH = "GET_UGC_SWATCH";
export const SAVE_UGC_SWATCH = "SAVE_UGC_SWATCH";

export const GET_ASSETS_3D = "GET_ASSETS_3D";
export const SAVE_ASSETS_3D = "SAVE_ASSETS_3D";
export const SET_ASSETS_3D = "SET_ASSETS_3D";

export const SET_CANVAS_IMAGE = "SET_CANVAS_IMAGE";

export const LOCK_FABRIC_FEATURES = "LOCK_FABRIC_FEATURES";

export const SET_UGC_VIEWS = "SET_UGC_VIEWS";
export const CHANGE_UGC_VIEW = "CHANGE_UGC_VIEW";
export const SET_CURRENT_FEATURE_UGC_VIEW = "SET_CURRENT_FEATURE_UGC_VIEW";
export const NEXT_UGC_VIEW = "NEXT_UGC_VIEW";
export const LOAD_VIEW = "LOAD_VIEW";

export const SAVE_MATERIAL = "SAVE_MATERIAL";
export const SAVE_TONAL_STITCH = "SAVE_TONAL_STITCH";

export const IS_GCC = "IS_GCC";
export const LOADING_UGC_FROM_ENTRYPOINT = "LOADING_UGC_FROM_ENTRYPOINT";

export const CREATE_UGC_FLOW_VIEWS = "CREATE_UGC_FLOW_VIEWS";
export const UGC_GATEWAY = "UGC_GATEWAY";

export const SET_UGC_BLOCKED_PALETTES = "SET_UGC_BLOCKED_PALETTES";
